/**
 * Header inline search with autocomplete dropdown (desktop).
 * Usa a seção padrão predictive-search e converte o HTML para o dropdown do header.
 */
(function () {
  if (!window.theme || !window.theme.routes || !window.theme.routes.predictive_search_url) return;

  const DEBOUNCE_MS = 250;
  const SECTION_ID = 'predictive-search';

  function initOne(wrapper) {
    const input = wrapper.querySelector('[data-header-inline-search-input]');
    const dropdown = wrapper.querySelector('[data-header-inline-search-dropdown]');
    const resultsEl = wrapper.querySelector('[data-header-inline-search-results]');
    const closeBtn = wrapper.querySelector('[data-header-inline-search-close]');
    const form = wrapper.querySelector('[data-header-inline-search-form]');

    if (!input || !dropdown || !resultsEl) return;

    /* Garantir que o dropdown comece oculto (sem resultados) */
    dropdown.setAttribute('hidden', '');

    let debounceTimer = null;
    const cachedResults = {};

    function getQueryKey(term) {
      return (term || '').replace(/\s+/g, '-').toLowerCase().trim();
    }

    function showDropdown() {
      dropdown.removeAttribute('hidden');
    }

    function hideDropdown() {
      dropdown.setAttribute('hidden', '');
    }

    function hasResults(container) {
      if (!container) return false;
      return container.querySelector('.header-search-dropdown__result') !== null ||
             container.querySelector('.header-search-dropdown__view-all') !== null;
    }

    function renderResults(html) {
      resultsEl.innerHTML = html || '';
      if (hasResults(resultsEl)) {
        showDropdown();
      } else {
        hideDropdown();
      }
    }

    /**
     * Converte o HTML da seção predictive-search (quick-search) no markup do dropdown do header.
     * Extrai apenas os produtos e o link "Ver todos".
     */
    function buildDropdownHtml(sectionHtml, searchTerm) {
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const products = doc.querySelectorAll('.quick-search__result--product');
      if (!products.length) return '';

      var root = (window.theme.routes && window.theme.routes.root) ? window.theme.routes.root.replace(/\/?$/, '') : '';
      const viewAllUrl = root + '/search?q=' + encodeURIComponent(searchTerm);
      const viewAllText = 'Ver todos os resultados';

      var listHtml = '<div class="header-search-dropdown__inner"><div class="header-search-dropdown__list" role="list">';
      var maxItems = 5;
      for (var i = 0; i < Math.min(products.length, maxItems); i++) {
        var a = products[i];
        var href = a.getAttribute('href') || '#';
        var imgWrap = a.querySelector('.quick-search__result-image-wrapper');
        var img = imgWrap ? imgWrap.querySelector('img') : a.querySelector('img');
        var imgSrc = img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '';
        var imgAlt = img ? (img.getAttribute('alt') || '') : '';
        var titleEl = a.querySelector('.quick-search__result-heading');
        var title = titleEl ? titleEl.textContent.trim() : '';
        var priceBlock = a.querySelector('.quick-search__result-price');
        var price = '';
        if (priceBlock) {
          var clone = priceBlock.cloneNode(true);
          var unitPrice = clone.querySelector('.unit-price');
          if (unitPrice) unitPrice.remove();
          price = clone.textContent.trim();
        }
        listHtml += '<a class="header-search-dropdown__result" href="' + escapeHtml(href) + '" role="listitem">';
        listHtml += '<div class="header-search-dropdown__result-image-wrapper">';
        if (imgSrc) {
          listHtml += '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(imgAlt) + '" loading="lazy" width="56" height="56">';
        }
        listHtml += '</div><div class="header-search-dropdown__result-details">';
        listHtml += '<div class="header-search-dropdown__result-heading">' + escapeHtml(title) + '</div>';
        listHtml += '<span class="header-search-dropdown__result-price">' + escapeHtml(price) + '</span>';
        listHtml += '</div></a>';
      }
      listHtml += '</div><a href="' + escapeHtml(viewAllUrl) + '" class="header-search-dropdown__view-all">' + escapeHtml(viewAllText) + '</a></div>';
      return listHtml;
    }

    function escapeHtml(s) {
      if (!s) return '';
      var div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }

    function fetchResults(searchTerm) {
      const queryKey = getQueryKey(searchTerm);
      if (!queryKey) {
        renderResults('');
        hideDropdown();
        return;
      }

      if (cachedResults[queryKey]) {
        renderResults(cachedResults[queryKey]);
        return;
      }

      const params = new URLSearchParams();
      params.set('section_id', SECTION_ID);
      params.set('q', searchTerm);
      if (window.theme.searchableFields) {
        params.set('resources[options][fields]', window.theme.searchableFields);
      }
      const url = window.theme.routes.predictive_search_url + '?' + params.toString();

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-' + SECTION_ID);
          const sectionHtml = section ? section.innerHTML : '';
          const html = buildDropdownHtml(sectionHtml, searchTerm);
          cachedResults[queryKey] = html;
          if (getQueryKey(input.value) === queryKey) {
            renderResults(html);
          }
        })
        .catch(function () {
          renderResults('');
        });
    }

    function onInput() {
      const value = (input.value || '').trim();
      clearTimeout(debounceTimer);
      if (!value) {
        renderResults('');
        hideDropdown();
        return;
      }
      debounceTimer = setTimeout(function () {
        fetchResults(value);
      }, DEBOUNCE_MS);
    }

    function onClose() {
      hideDropdown();
      input.value = '';
      resultsEl.innerHTML = '';
    }

    function onDocumentClick(e) {
      if (dropdown.hasAttribute('hidden')) return;
      if (wrapper.contains(e.target)) return;
      hideDropdown();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        hideDropdown();
        input.blur();
      }
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (hasResults(resultsEl)) showDropdown();
    });
    if (closeBtn) closeBtn.addEventListener('click', onClose);
    form.addEventListener('submit', function (e) {
      if (!(input.value || '').trim()) e.preventDefault();
    });
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);
  }

  function init() {
    const wrappers = document.querySelectorAll('[data-header-inline-search]');
    wrappers.forEach(function (wrapper) {
      initOne(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
